import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=354fd3d1"
import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports